import { useEffect, useState } from 'react';
import { apiClient } from '../../../services/api/client';

export const useModelConfigs = () => {
  const [modelConfigs, setModelConfigs] = useState<
    Array<{ key: string; label: string; isDefault: boolean }>
  >([]);
  const [selectedModelConfig, setSelectedModelConfig] = useState<string>(() => {
    try {
      return window.localStorage.getItem('playground.modelConfig') ?? 'standard';
    } catch {
      return 'standard';
    }
  });
  const [lastBrainModel, setLastBrainModel] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get('/admin/model-configs')
      .then((res) => {
        if (cancelled) return;
        const configs = (
          res.data as {
            configs?: Array<{ key: string; label: string; isDefault: boolean }>;
          } | null
        )?.configs;
        if (Array.isArray(configs) && configs.length > 0) {
          setModelConfigs(configs);
          setSelectedModelConfig((current) =>
            configs.some((config) => config.key === current) ? current : 'standard',
          );
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const handleModelConfigChange = (key: string) => {
    setSelectedModelConfig(key);
    try {
      window.localStorage.setItem('playground.modelConfig', key);
    } catch {}
  };

  return {
    modelConfigs,
    selectedModelConfig,
    handleModelConfigChange,
    lastBrainModel,
    setLastBrainModel,
  };
};
